import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin--users--form"
export default class extends Controller {
  static targets = ["form", "username"];

  connect() {
    this.updateBreadcrumbUsername();
  }

  updateBreadcrumbUsername() {
    const breadcrumbUsername = document.getElementById("user-username");
    breadcrumbUsername.textContent = this.usernameTarget.value ?? "―";
  }
}
